export default class AnchorSelect {
	constructor(root) {
		root?.addEventListener('change', (e) => {
			window.location.hash = e.target.value;
		});
	}
}
